import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { RingPattern } from '../../constants/constants';
import { CommonModule } from '@angular/common';
import { MatRippleModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { environment } from '../../../environment/environment';

@Component({
  selector: 'app-ring-btn',
  imports: [
    MatIconModule,
    MatButtonModule,
    MatCardModule,
    MatProgressBarModule,
    MatRippleModule,
    MatInputModule,
    CommonModule
  ],
  templateUrl: './ring-btn.component.html',
  styleUrls: ['./ring-btn.component.scss', '../ring-functions.component.scss']
})
export class RingBtnComponent {

  @Input() pattern: RingPattern;
  @Output() triggerRing: EventEmitter<string> = new EventEmitter<string>();

  pressProgress: number = 0;
  isHoldingPress: boolean = false;
  private holdTimeout:any;
  private interval: any;
  private readonly HOLD_DURATION = 1500;
  isController: boolean = environment.isController;

  startPress(patternId: string, event: Event){
    if (this.isHoldingPress) return;
    event.preventDefault();
    event.stopPropagation();
    this.isHoldingPress = true;
    this.pressProgress = 0;
    const startTime = Date.now();
    this.interval = setInterval(()=>{
      const elapsed = Date.now() - startTime;
      this.pressProgress = Math.min(100, (elapsed/this.HOLD_DURATION)*100);
      if(elapsed >= this.HOLD_DURATION){
        this.endPress(true, patternId);
      }
    }, 180);
  }

  endPress(triggerRing: boolean = false, patternId?: string){
    if (!this.isHoldingPress) return;
    this.pressProgress = 0;
    this.isHoldingPress = false;
    clearInterval(this.interval);
    this.interval = null;
    if(triggerRing && patternId != null){
      this.triggerRing.emit(patternId);
    }
  }
}
